module.exports = __webpack_public_path__ + "static/img/guidance3.5e5e943d.webp";